import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, effect, inject, untracked } from '@angular/core';
import { CallTabSyncService } from 'src/app/shared/agent-desktop/telephony/services/call-tab-sync.service';
import { RingtoneService } from 'src/app/shared/agent-desktop/telephony/services/ringtone.service';
import { ScheduledCallOfferService } from './scheduled-call-offer.service';

/** `<html>` class behind the Agent Desktop side-menu badge in src/styles.scss (K-130). */
export const SCHEDULED_CALL_OFFER_MENU_BADGE_CLASS = 'acx-scheduled-call-offer';

/**
 * Route-wide offer alarm (154880/6, K-172): one root owner, so two toast hosts never double the sound.
 * Follows `toastVisible`, so Take (any tab), Abandon, Call Now, `ended` and a busy phone silence all of it.
 */
@Injectable({ providedIn: 'root' })
export class ScheduledCallOfferAlertService {
  private readonly offerService = inject(ScheduledCallOfferService);
  private readonly ringtone = inject(RingtoneService);
  private readonly callTabSync = inject(CallTabSyncService);
  private readonly document = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  private alerting = false;

  constructor() {
    effect(() => {
      const alerting = this.offerService.toastVisible();
      untracked(() => this.apply(alerting));
    });

    this.destroyRef.onDestroy(() => this.apply(false));
  }

  private apply(alerting: boolean): void {
    if (alerting === this.alerting) {
      return;
    }

    this.alerting = alerting;
    if (alerting) {
      this.ringtone.startOfferAlert();
    } else {
      this.ringtone.stopOfferAlert();
    }

    this.callTabSync.setScheduledCallOfferAlert(alerting);
    this.document.documentElement.classList.toggle(SCHEDULED_CALL_OFFER_MENU_BADGE_CLASS, alerting);
  }
}
